import React, { Component } from 'react';
import { getEnvelopeDetails } from './helpers/fireHelper';
import EnvelopeContainer from './_EnvelopeContainer';
import MediaQuery from 'react-responsive';
// import MobileScaler from './_MobileScaler';
import MobileEmbed from './_MobileEmbed';
// import DesktopEmbed from './_DesktopEmbed';

class _Embed extends Component {
  constructor() {
    super()
    this.state = {
      window: { width: 0, height: 0 },
      envelope: null,
      data: 'on',
      scale: 'off',
      scalemobile: 'off'
    }
  }

  componentDidMount() {
    this.getWindowHeight();
    const data = this.splitSearch(this.props.location.search, this.state).data

    // console.log(this.props.match.params.key);
    // console.log('START GET NOW...');
    getEnvelopeDetails(this.props.match.params.key)
      .then(envelope => {
        // console.log('DATA:', data);
        // console.log('WEL:', this.props.location.search);
        this.setState({ envelope, data })
      })
      .catch(error => console.error(error))
  }

  getWindowHeight = () => {
    var w = window,
    d = document,
    e = d.documentElement,
    g = d.getElementsByTagName('body')[0],
    x = w.innerWidth || e.clientWidth || g.clientWidth,
    y = w.innerHeight|| e.clientHeight|| g.clientHeight;
    this.setState({ window: { width: x, height: y}})
  }

  // componentDidMount() {
  //   // var { data, scale } = params;
  //   // data  = typeof data  === "undefined" ? this.state.data : data;
  //   // scale = typeof scale === "undefined" ? this.state.scale : scale;
  //   // scalemobile = typeof scalemobile === "undefined" ? this.state.scalemobile : scalemobile;
  //   // const id = this.props.match.params.key;
  //   // getEnvelopeDetails(id)
  //   //   .then(envelope => {
  //   //     this.setState({ envelope, data, scale })
  //   // })
  // }

  navigateToEditPage = () => {
    window.open('https://envelope.li/edit/' + this.props.match.params.key, '_blank');
  }
  render() {
    return (
      <div>
        <MediaQuery query="(min-device-width: 1224px)">
          <EnvelopeContainer
            navigateToEditPage={this.navigateToEditPage}
            window={this.state.window}
            data={this.state.data}
            envelope={this.state.envelope}
          />
        </MediaQuery>
        <MediaQuery query="(max-device-width: 1224px)">
          <MobileEmbed
            navigateToEditPage={this.navigateToEditPage}
            window={this.state.window}
            envelope={this.state.envelope}
          />
        </MediaQuery>
        {/* <MediaQuery query="(min-device-width: 1224px)">
          <EnvelopeContainer
            mobile={false}
            envelope={this.state.envelope}
            navigateToEditPage={this.navigateToEditPage}
            data={this.state.data}
            scale={this.state.scale}
            scalemobile={this.state.scalemobile}
          />
        </MediaQuery>
        <MediaQuery query="(max-device-width: 1224px)">
          <MobileScaler
            mobile={true}
            envelope={this.state.envelope}
            navigateToEditPage={this.navigateToEditPage}
            data={'off'}
            scale={this.state.scale}
            scalemobile={this.state.scalemobile}
          />
        </MediaQuery> */}

      </div>
    );
  }
  splitSearch = (str) => {
    var nstr = str.split("?")[1];
    if (typeof nstr === "undefined") return {};
    var arr = nstr.split("&");
    var obj = {};
    arr.forEach(el => {
      var spl = el.split("=");
      obj[spl[0]] = spl[1];
    })
    return obj;
  }
}

export default _Embed;



// WEBPACK FOOTER //
// ./src/_Embed.js